module.exports = __webpack_public_path__ + "way2go/static/config/audio_alerm_clock.mp3";